import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import React, { useEffect } from "react";
import { Button } from "react-bootstrap";
import {
  genReport24Q_EmployerHeader,
  genReport24Q_DeducteeHeader,
  genReport24Q_ChallanHeader,
  getReport24Q_SalaryDetailHeader,
  getLastDateOfMonth,
} from "./client/misc";
import {
  getAssessmentYear,
  addMonthNumberAndSort,
  calculateTaxFromJSON,
  calculateOldRegimeTax,
  getAgeCategoryFromDOB,
} from "./admin/misc";
import moment from "moment";
import {
  applyGenusTextFormat,
  applyGenusNumberFormat,
  wrapHeaderText,
} from "./excelFormat24QAnnex2";

const ExportToExcelGen24Q = ({
  employerData,
  challanData,
  deducteeData,
  salaryDetailData,
  fileName,
  formName,
  clientName = "",
  clientTan = "",
  financialYear,
  month = "",
  selectedQuarter,
  //txRgmType = "",
}) => {
  const dData = addMonthNumberAndSort(deducteeData, "mn");
  if (dData.length > 0) {
    deducteeData = dData;
  }

  const chData = addMonthNumberAndSort(challanData, "mn");
  if (chData.length > 0) {
    challanData = chData;
  }

  console.log("d data", employerData);
  console.log("financialYear", financialYear);
  // console.log("ch data", challanData);

  const extractKeyValues = (arr, keyName) => arr.map((item) => item[keyName]);

  const filterDataByKeys = (columns, data) => {
    const allowedKeys = columns.map((col) => col.key);
    return data.map((item) => {
      const filtered = {};
      allowedKeys.forEach((key) => {
        filtered[key] = item.hasOwnProperty(key) ? item[key] : "";
      });
      return filtered;
    });
  };

  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    let fYear = financialYear.split("-");
    // Example: array of sheets with header/data source mappings
    const sheetsConfig = [
      {
        name: "EmployerDetails",
        headerKeyArray: genReport24Q_EmployerHeader,
        data: employerData,
        sheet: "sheet1",
      },
      {
        name: "ChallanDetails",
        headerKeyArray: genReport24Q_ChallanHeader,
        data: challanData,
        sheet: "sheet2",
      },
      {
        name: "Annex-I_DeducteeDetails",
        headerKeyArray: genReport24Q_DeducteeHeader,
        data: deducteeData,
        sheet: "sheet3",
      },
      {
        name: "Annex-II_SalaryDetailsN",
        headerKeyArray: getReport24Q_SalaryDetailHeader,
        data: salaryDetailData,
        sheet: "sheet4",
      },
    ];
    let worksheet = "";
    let sheetNum = 0;
    sheetsConfig.forEach(({ name, headerKeyArray, data, sheet }) => {
      worksheet = workbook.addWorksheet(
        sheet === "sheet4" ? `${name}${fYear[0]}` : name
      );

      const headers = extractKeyValues(headerKeyArray, "label");

      if (sheet === "sheet1") {
        sheetNum = 1;
        //SHEET 1
        const colCData = [
          "A.Y.",
          getAssessmentYear(financialYear),
          "Quarter",
          selectedQuarter,
          "Form No.",
          "24Q",
        ];
        const filteredData = filterDataByKeys(headerKeyArray, data);
        const firstRecord = filteredData[0] || {};

        let rowIndex = 1;
        headers.forEach((header, idx) => {
          const row = worksheet.getRow(rowIndex++);
          row.getCell(1).value = header;
          row.getCell(2).value =
            firstRecord[headerKeyArray[idx].key].toUpperCase() || "";
          row.getCell(1).font = { bold: true, size: 10 };
          row.getCell(2).font = { size: 10 };
          row.getCell(1).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "CCECFF" },
          };
          row.alignment = { horizontal: "left", vertical: "middle" };
        });
        headers.forEach((header, i) => {
          worksheet.getColumn(1).width = Math.max(header.length + 5, 55);
          worksheet.getColumn(2).width = Math.max(header.length + 5, 40);
          worksheet.getColumn(3).width = Math.max(15, 3);
        });
        colCData.forEach((value, index) => {
          const cell = worksheet.getCell(`C${index + 1}`);
          cell.value = value;
          cell.alignment = { horizontal: "center", vertical: "middle" };
          cell.font = { bold: true };
        });
      } else if (sheet === "sheet4") {
        sheetNum = 4;
        let cell = "";
        let cell9 = 0;
        let cell10 = 0;
        let cell11 = 0;
        let cell12 = 0;
        let cell13 = 0;
        let cell14 = 0;
        let cell15 = 0;
        let cell16 = 0;
        let cell17 = 0;
        let cell18 = 0;
        let cell19 = 0;
        let cell20 = 0;
        let cell21 = 0;
        let cell22 = 0;
        let cell23 = 0;
        let cell25 = 0;
        let cell26 = 0;
        let cell27 = 0;
        let cell28 = 0;
        let cell29 = 0;
        let cell30 = 0;
        let cell31 = 0;
        let cell32 = 0;
        let cell62 = 0;
        let cell64 = 0;
        let cell65 = 0;
        let cell67 = 0;
        let cell68 = 0;
        let cell69 = 0;
        let cell70 = 0;
        let cell71 = 0;
        let cell72 = 0;
        let cell73 = 0;
        let cell74 = 0;
        let cell75 = 0;
        let cell76 = 0;
        let cell85 = 0;
        let cell105 = 0;

        const headerRow = worksheet.getRow(1);
        headerRow.height = 100;

        let colIndex = 1;
        const subHeaders = {
          //31: ["Gross", "Deductible"],
          32: ["Gross", "Deductible"],
          33: ["Gross", "Deductible"],
          34: ["Gross", "Deductible"],
          35: ["Gross", "Deductible"],
          36: ["Gross", "Deductible"],
          37: ["Gross", "Deductible"],
          38: ["Gross", "Deductible"],
          39: ["Gross", "Deductible"],
          40: ["Gross", "Deductible"],
          41: ["Gross", "Deductible"],
          42: ["Gross", "Qualifying", "Deductible"],
          43: ["Gross", "Qualifying", "Deductible"],
          44: ["Gross", "Qualifying", "Deductible"],
        };

        headers.forEach((header, index) => {
          if (header === "gender") return;
          let cell;

          const mergeMap = {
            //31: "AF1:AG1",
            32: "AG1:AH1",
            33: "AI1:AJ1",
            34: "AK1:AL1",
            35: "AM1:AN1",
            36: "AO1:AP1",
            37: "AQ1:AR1",
            38: "AS1:AT1",
            39: "AU1:AV1",
            40: "AW1:AX1",
            41: "AY1:AZ1",
            42: "BA1:BC1",
            43: "BD1:BF1",
            44: "BG1:BI1",
          };

          if (mergeMap[index]) {
            worksheet.mergeCells(mergeMap[index]);
            const startCell = mergeMap[index].split(":")[0];
            cell = worksheet.getCell(startCell);
            cell.value = header;

            // --- add sub headers in row 2
            const [start, end] = mergeMap[index].split(":");
            const startCol = worksheet.getCell(start).col;
            const endCol = worksheet.getCell(end).col;

            if (subHeaders[index]) {
              subHeaders[index].forEach((sub, i) => {
                worksheet.getRow(2).getCell(startCol + i).value = sub;
              });
            }

            colIndex = endCol + 1;
          } else {
            cell = headerRow.getCell(colIndex);
            cell.value = header;
            //worksheet.getRow(2).getCell(colIndex).value = "";
            worksheet.mergeCells(1, colIndex, 2, colIndex);
            colIndex++;
          }

          // Apply styles
          cell.font = { bold: true, size: 8.5, color: { argb: "2c3e50" } };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "CCECFF" },
          };
          cell.alignment = {
            horizontal: "center",
            vertical: "middle",
            wrapText: true,
          };

          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
          };
          const row2 = worksheet.getRow(2);
          row2.eachCell((cell) => {
            //cell.alignment = { vertical: "middle", horizontal: "center" };
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "CCECFF" }, // ✅ light blue
            };
            cell.border = {
              bottom: { style: "thin" },
              left: { style: "thin" },
              top: { style: "thin" },
            };
          });
          for (let i = 1; i <= 100; i++) {
            worksheet.getColumn(i).width = 15;
            //worksheet.mergeCells(1, colIndex, 2, colIndex);
          }
        });

        console.log("headerKeyArray, data", headerKeyArray, data);
        const filteredData = filterDataByKeys(headerKeyArray, data);
        let rowIndex = 3;

        if (selectedQuarter !== "Q4") {
          filteredData.forEach((item, dataIndex) => {
            const row = worksheet.getRow(3);
            Object.values(item).forEach((value, colIndex) => {
              const cell = row.getCell(colIndex + 1);
              if (
                colIndex === 12 ||
                colIndex === 14 ||
                colIndex === 24 ||
                colIndex === 27 ||
                colIndex === 28 ||
                colIndex === 31 ||
                colIndex === 62 ||
                colIndex === 67 ||
                colIndex === 69 ||
                colIndex === 70 ||
                colIndex === 72 ||
                colIndex === 75 ||
                colIndex === 76
              ) {
                cell.value = 0;
              }
            });
          });
        }

        if (selectedQuarter === "Q4") {
          const TOTAL_COLUMNS = 105;
          console.log("-----------------> Q4 -> filteredData", filteredData);
          filteredData.forEach((item, dataIndex) => {
            console.log("-----------------> Q4 -> item", item);
            const row = worksheet.getRow(rowIndex++);
            // Object.values(item).forEach((value, colIndex) => {
            for (let colIndex = 0; colIndex < TOTAL_COLUMNS; colIndex++) {
              const value = Object.values(item)[colIndex];
              const cell = row.getCell(colIndex + 1);
              // console.log("-----> Q4 -> ", value, " Index = ", colIndex);
              cell.value =
                value !== null && value !== undefined && value !== ""
                  ? String(value).toUpperCase()
                  : "";
              if (colIndex === 0) {
                cell.value = dataIndex + 1;
              } else if (colIndex === 6) {
                cell.value = `01/04/${fYear[0]}`;
                cell.alignment = { horizontal: "center", vertical: "middle" };
                cell.numFmt = "@";
              } else if (colIndex === 7) {
                cell.value = `31/03/${fYear[1]}`;
                cell.alignment = { horizontal: "center", vertical: "middle" };
                cell.numFmt = "@";
              } else if (colIndex === 12) {
                // M = J + K+ L
                cell10 = row.getCell(10); // J
                cell11 = row.getCell(11); // K
                cell12 = row.getCell(12); // L
                const sum =
                  (Number(cell10.value) || 0) +
                  (Number(cell11.value) || 0) +
                  (Number(cell12.value) || 0);

                cell.alignment = { horizontal: "right", vertical: "middle" };
                cell.value = Number(sum).toFixed(2);
              } else if (colIndex === 14) {
                // O = M + N
                cell13 = row.getCell(13); // M
                cell14 = row.getCell(14); // N
                cell.value =
                  (parseFloat(cell13.value) || 0) +
                  (parseFloat(cell14.value) || 0);
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 22) {
                // W = Total of P to V
                cell16 = row.getCell(16); // P
                cell17 = row.getCell(17); // Q
                cell18 = row.getCell(18); // R
                cell19 = row.getCell(19); // S
                cell20 = row.getCell(20); // T
                cell21 = row.getCell(21); // U
                cell22 = row.getCell(22); // V
                cell.value =
                  (parseFloat(cell16.value) || 0) +
                  (parseFloat(cell17.value) || 0) +
                  (parseFloat(cell18.value) || 0) +
                  (parseFloat(cell19.value) || 0) +
                  (parseFloat(cell20.value) || 0) +
                  (parseFloat(cell21.value) || 0) +
                  (parseFloat(cell22.value) || 0);
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 24) {
                //cell.value = txRgmType === "oldTxRgm" ? "50000.00" : "75000.00";
                const value = Number(cell10.value) || 0;

                cell.value =
                  item.nt === 1
                    ? Math.min(value, 75000)
                    : Math.min(value, 50000);
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 27) {
                // AB = Y + Z + AA
                cell25 = row.getCell(25); // Y
                cell26 = row.getCell(26); // Z
                cell27 = row.getCell(27); // AA
                cell.value =
                  (parseFloat(cell25.value) || 0) +
                  (parseFloat(cell26.value) || 0) +
                  (parseFloat(cell27.value) || 0);
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 28) {
                // AC = O - W - AB
                cell15 = row.getCell(15) || 0; // o
                cell23 = row.getCell(23) || 0; // W
                cell28 = row.getCell(28) || 0; // AB
                cell.value =
                  (parseFloat(cell15.value) || 0) -
                  (parseFloat(cell23.value) || 0) -
                  (parseFloat(cell28.value) || 0);
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 31) {
                // AF = AC + AD + AE
                cell29 = row.getCell(29) || 0; // AC
                cell30 = row.getCell(30) || 0; // AD
                cell31 = row.getCell(31) || 0; // AE
                cell.value =
                  (parseFloat(cell29.value) || 0) +
                  (parseFloat(cell30.value) || 0) +
                  (parseFloat(cell31.value) || 0);
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 32 || colIndex === 33) {
                cell.value = item.nt === 1 ? 0 : parseFloat(item.d80c, 2) || 0;
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 34 || colIndex === 35) {
                cell.value = 0;
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 36 || colIndex === 37) {
                cell.value =
                  item.nt === 1 ? 0 : parseFloat(item.d80ccd, 2) || 0;
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 38 || colIndex === 39) {
                cell.value =
                  item.nt === 1 ? 0 : parseFloat(item.d80ccd1bc, 2) || 0;
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 40 || colIndex === 41) {
                // cell.value = parseFloat(item.d80ccd1bc, 2) || 0;
                cell.value = 0;
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 42 || colIndex === 43) {
                cell.value = 0;
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 44 || colIndex === 45) {
                cell.value = 0;
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 46 || colIndex === 47) {
                cell.value = 0;
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 48 || colIndex === 49) {
                cell.value = item.nt === 1 ? 0 : parseFloat(item.d80d, 2) || 0;
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 50 || colIndex === 51) {
                cell.value = 0;
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (
                colIndex === 52 ||
                colIndex === 53 ||
                colIndex === 54
              ) {
                cell.value = item.nt === 1 ? 0 : parseFloat(item.d80g, 2) || 0;
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (
                colIndex === 55 ||
                colIndex === 56 ||
                colIndex === 57
              ) {
                cell.value = 0;
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (
                colIndex === 58 ||
                colIndex === 59 ||
                colIndex === 60
              ) {
                cell.value = 0;
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 61) {
                cell.value = parseFloat(item.td, 2) || 0;
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 62) {
                // BK = AF - BJ
                cell32 = row.getCell(32) || 0; // AF
                cell62 = row.getCell(62) || 0; // BJ
                cell.value =
                  (parseFloat(cell32.value) || 0) -
                  (parseFloat(cell62.value) || 0);
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 64) {
                cell32 = row.getCell(32) || 0; // AF
                cell62 = row.getCell(62) || 0; // BJ
                let salary =
                  (parseFloat(cell32.value) || 0) -
                  (parseFloat(cell62.value) || 0);

                if (item.nt === 1) {
                  cell.value = calculateTaxFromJSON(salary, financialYear);
                } else {
                  const ageCategory = getAgeCategoryFromDOB(item.ed);
                  console.log(
                    "ttttttt",
                    salary,
                    financialYear,
                    item.eg || "Male",
                    ageCategory
                  );
                  cell.value = calculateOldRegimeTax(
                    salary,
                    financialYear,
                    item.eg || "Male",
                    ageCategory
                  );
                }
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 67) {
                // BP = BM - BO
                cell65 = row.getCell(65) || 0; // BM
                cell67 = row.getCell(67) || 0; // BO
                cell.value =
                  (parseFloat(cell65.value) || 0) -
                  (parseFloat(cell67.value) || 0);
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 69) {
                // BR = BP + BQ
                cell68 = row.getCell(68) || 0; // BP
                cell69 = row.getCell(69) || 0; // BQ
                // cell.value =
                //   (parseFloat(cell68.value) || 0) +
                //   (parseFloat(cell69.value) || 0);
                cell.value = ((parseFloat(cell68.value) || 0) * 4) / 100;
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 70) {
                // BS = BP + BQ + BR
                cell68 = row.getCell(68) || 0; // BP
                cell69 = row.getCell(69) || 0; // BQ
                cell70 = row.getCell(70) || 0; // BR
                cell.value =
                  (parseFloat(cell68.value) || 0) +
                  (parseFloat(cell69.value) || 0) +
                  (parseFloat(cell70.value) || 0);
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 72) {
                // BU = BS - BT
                cell71 = row.getCell(71) || 0; // BS
                cell72 = row.getCell(72) || 0; // BT
                cell.value =
                  (parseFloat(cell71.value) || 0) -
                  (parseFloat(cell72.value) || 0);
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 73) {
                cell65 = row.getCell(65) || 0; // AF
                cell.value = Math.min(cell65).toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 75) {
                // BX = BV + BW + CG + DA
                cell74 = row.getCell(74) || 0; // BV
                cell75 = row.getCell(75) || 0; // BW
                cell85 = row.getCell(85) || 0; // CG
                cell105 = row.getCell(105) || 0; // DA
                cell.value =
                  (parseFloat(cell74.value) || 0) +
                  (parseFloat(cell75.value) || 0) +
                  (parseFloat(cell85.value) || 0) +
                  (parseFloat(cell105.value) || 0);
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 76) {
                // BY = BU - BX
                cell73 = row.getCell(73) || 0; // BU
                cell76 = row.getCell(76) || 0; // BX
                cell.value =
                  (parseFloat(cell73.value) || 0) -
                  (parseFloat(cell76.value) || 0);
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 23) {
                //cell.value = txRgmType === "oldTxRgm" ? "No" : "Yes";
                cell.value = "No";
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 63 || colIndex === 65) {
                cell.value = "No";
                cell.alignment = { horizontal: "center", vertical: "middle" };
              } else if (colIndex === 8) {
                cell.value = item.nt === 1 ? "Yes" : "No";
                cell.alignment = { horizontal: "center", vertical: "middle" };
              } else if (
                colIndex === 77 ||
                colIndex === 78 ||
                colIndex === 85 ||
                colIndex === 94 ||
                colIndex === 103
              ) {
                cell.value = "No";
                cell.alignment = { horizontal: "center", vertical: "middle" };
              } else if (
                colIndex === 10 ||
                colIndex === 11 ||
                colIndex === 13 ||
                colIndex === 15 ||
                colIndex === 16 ||
                colIndex === 17 ||
                colIndex === 18 ||
                colIndex === 19 ||
                colIndex === 20 ||
                colIndex === 21 ||
                colIndex === 22 ||
                colIndex === 25 ||
                colIndex === 26 ||
                colIndex === 29 ||
                colIndex === 30 ||
                colIndex === 50 ||
                colIndex === 51 ||
                colIndex === 52 ||
                colIndex === 53 ||
                colIndex === 54 ||
                colIndex === 55 ||
                colIndex === 59 ||
                colIndex === 61 ||
                colIndex === 61 ||
                colIndex === 64 ||
                colIndex === 66 ||
                colIndex === 68 ||
                colIndex === 71 ||
                colIndex === 74 ||
                colIndex === 104
              ) {
                cell.value = 0;
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 9) {
                cell.alignment = { horizontal: "right", vertical: "middle" };
              }
              cell.font = { size: 9.5 };
              //});
            }
          });
        }
      } else {
        const headerRow = worksheet.getRow(1);
        headerRow.height = 70;
        headers.forEach((header, index) => {
          const cell = headerRow.getCell(index + 1);
          cell.value = header;

          cell.font = { bold: true, size: 8.5, color: { argb: "2c3e50" } };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "CCECFF" },
          };
          cell.alignment = {
            horizontal: "center",
            vertical: sheet === "sheet4" ? "top" : "middle",
            wrapText: true,
          };
          cell.border = {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          };
          worksheet.getColumn(index + 1).width = 15;
        });

        const filteredData = filterDataByKeys(headerKeyArray, data);
        let rowIndex = 2;
        let serialCounter = 0;
        let currentMonth = "";

        filteredData.forEach((item, dataIndex) => {
          const row = worksheet.getRow(rowIndex++);
          Object.values(item).forEach((value, colIndex) => {
            const cell = row.getCell(colIndex + 1);

            if (sheet === "sheet3") {
              sheetNum = 3;
              //SHEET 3
              if (item.mn !== currentMonth) {
                serialCounter++;
                currentMonth = item.mn;
              }
              cell.value = value || "";
              if (colIndex === 0) {
                cell.value = serialCounter;
                cell.alignment = { horizontal: "center", vertical: "middle" };
              } else if (colIndex === 1) {
                cell.value = "92A";
                cell.alignment = { horizontal: "center", vertical: "middle" };
              } else if (colIndex === 6) {
                let dt = getLastDateOfMonth(item.mn, financialYear);
                cell.value = moment(dt, "DD-MM-YYYY").format("DD/MM/YYYY");
                cell.alignment = { horizontal: "center", vertical: "middle" };
                cell.numFmt = "@";
              } else if (colIndex === 11) {
                const tdsValue = row.getCell(9).value;
                cell.value = tdsValue;
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 12) {
                const prevValue = row.getCell(colIndex).value;
                // cell.value =
                //   prevValue > 0
                //     ? getLastDateOfMonth(item.mn, financialYear)
                //     : "";
                if (prevValue > 0) {
                  let dt = getLastDateOfMonth(item.mn, financialYear);
                  cell.value = moment(dt, "DD-MM-YYYY").format("DD/MM/YYYY");
                  cell.alignment = { horizontal: "center", vertical: "middle" };
                  cell.numFmt = "@";
                } else {
                  cell.value = "";
                }
                cell.alignment = { horizontal: "center", vertical: "middle" };
              } else if (colIndex === 7 || colIndex === 8) {
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 9 || colIndex === 10) {
                cell.value = 0;
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              }
            } else if (sheet === "sheet2") {
              sheetNum = 2;
              //SHEET 2
              cell.value = value || "";
              if (colIndex === 0) {
                cell.value = dataIndex + 1;
                cell.alignment = { horizontal: "center", vertical: "middle" };
              } else if (colIndex === 1) {
                cell.value = "92A";
                cell.alignment = { horizontal: "center", vertical: "middle" };
              } else if (colIndex === 8) {
                const tds = row.getCell(3).value;
                const interest = row.getCell(6).value;
                const lateFee = row.getCell(7).value;
                cell.value =
                  parseFloat(tds) + parseFloat(interest) + parseFloat(lateFee);
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 2 || colIndex === 5 || colIndex === 6) {
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (
                colIndex === 3 ||
                colIndex === 4 ||
                colIndex === 7 ||
                colIndex === 15 ||
                colIndex === 16
              ) {
                cell.value = 0;
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 10 || colIndex === 12) {
                cell.alignment = { horizontal: "center", vertical: "middle" };
              } else if (colIndex === 13) {
                cell.value = employerData[0].igoc === 1 ? "Yes" : "No";
                cell.alignment = { horizontal: "center", vertical: "middle" };
              } else if (colIndex === 11) {
                cell.alignment = { horizontal: "center", vertical: "middle" };
                cell.value = moment(value).format("DD/MM/YYYY");
                cell.numFmt = "@";
              }
            } else if (sheet === "sheet1") {
              cell.value = value || "";
            }

            cell.font = { size: 9.5 };
          });
        });
      }
    });

    if (sheetNum === 4) {
      applyGenusTextFormat(worksheet);
      applyGenusNumberFormat(worksheet);
    }
    // Save only once after all sheets are created
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `${fileName}.xlsx`);
  };

  // const exportToExcel = async () => {
  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet1 = workbook.addWorksheet("EmployerDetails");
  //   const worksheet2 = workbook.addWorksheet("ChallanDetails");
  //   const worksheet = workbook.addWorksheet("Annex-I_DeducteeDetails");

  //   const headerAndKeyArray = genReport24Q_DeducteeHeader;
  //   const headers = extractKeyValues(headerAndKeyArray, "label");

  //   const headerRow = worksheet.getRow(3);
  //   headers.forEach((header, index) => {
  //     const cell = headerRow.getCell(index + 1);
  //     cell.value = header;
  //     cell.font = { bold: true, size: 11, color: { argb: "FFFFFFFF" } };
  //     cell.fill = {
  //       type: "pattern",
  //       pattern: "solid",
  //       fgColor: { argb: "FF4CAF50" },
  //     };
  //     cell.alignment = { horizontal: "center", vertical: "middle" };
  //     cell.border = {
  //       top: { style: "thin" },
  //       bottom: { style: "thin" },
  //       left: { style: "thin" },
  //       right: { style: "thin" },
  //     };
  //   });
  //   headerRow.height = 25;

  //   // Adjust column widths
  //   headers.forEach((header, i) => {
  //     worksheet.getColumn(i + 1).width = Math.max(header.length + 5, 25);
  //   });

  //   // Data Rows
  //   const filteredData = filterDataByKeys(headerAndKeyArray, data);
  //   let rowIndex = 4;

  //   filteredData.forEach((item, dataIndex) => {
  //     const row = worksheet.getRow(rowIndex++);

  //     Object.values(item).forEach((value, colIndex) => {
  //       const cell = row.getCell(colIndex + 1);

  //       if (formName === "genreport24q") {
  //         if (colIndex === 0) {
  //           cell.value = dataIndex + 1; // Serial No
  //         } else if (colIndex === 1) {
  //           cell.value = "92A"; // Example fixed value
  //         } else if (colIndex === 6) {
  //           cell.value = getLastDateOfMonth(month, financialYear); // Example date logic
  //         } else if (colIndex === 12) {
  //           const prevValue = row.getCell(colIndex).value;
  //           cell.value = prevValue ? getLastDateOfMonth(month, financialYear) : "";
  //         } else {
  //           cell.value = value;
  //         }
  //       } else {
  //         cell.value = value;
  //       }
  //       cell.value = value;
  //       cell.alignment = { horizontal: "center", vertical: "middle" };
  //       cell.font = { size: 11 };
  //     });
  //   });

  //   // Save file
  //   const buffer = await workbook.xlsx.writeBuffer();
  //   const blob = new Blob([buffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });
  //   saveAs(blob, `${fileName}.xlsx`);
  // };

  return (
    <Button
      variant="success"
      onClick={exportToExcel}
      disabled={
        employerData.length === 0 ||
        challanData.length === 0 ||
        deducteeData.length === 0
      }
    >
      Generate Report
    </Button>
  );
};

export default ExportToExcelGen24Q;
